class FooterController {
  constructor ($interval, $state, Localization, I18n) {
    'ngInject'

    this.I18n = I18n
    this.country = Localization.getCountry().toUpperCase()
    let tick = () => {
      if (!this.clock) {
        this.clock = Date.now()
        return
      }
      let now = new Date()
      if (new Date(this.clock).getMinutes() !== now.getMinutes()) {
        this.clock = now.getTime()
      }
    }
    tick()
    $interval(tick, 1000)
    this.$state = $state
  }

  isMaintenance () {
    return this.$state.is('maintenance')
  }

}

export default FooterController



// WEBPACK FOOTER //
// ./src/app/common/footer/footer.controller.js